export default __webpack_public_path__ + "28135cc0838ed304ec1c0c29670a15e3.webp";